import { Component, OnInit } from '@angular/core';
import { Category } from './category';
import { StoredChemical } from './stored-chemical';
import { StorageTime } from './storage-time';
import { MinTemp } from './min-temp';
import { MaxTemp } from './max-temp';
import { Material } from './material';
import { Color } from './color';
import { Shape } from './shape';
import { Drain } from './drain';
import { MouthSize } from './mouth-size';
import { Certification } from './certification';
import { StorageSize } from './storage-size';
import { BulkPack } from './bulk-pack';
import { Autoclavable } from './autoclavable';
import { Neck } from './neck';
import { NeckFinish } from './neck-finish';
import { Nalgene } from './nalgene';
import { CategoryService } from './category.service';
import { ProductsService } from './nalgenes/products.service';
import { stringify, dashCaseToCamelCase } from '@angular/compiler/src/util';
import { element } from 'protractor';


@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

  public categories: Category[];
  public stored_chemicals: StoredChemical[];
  public storage_times: StorageTime[];
  public min_temps: MinTemp[];
  public max_temps: MaxTemp[];
  public materials: Material[];
  public colors: Color[];
  public shapes: Shape[];
  public drains: Drain[];
  public mouth_sizes: MouthSize[];
  public storage_sizes:StorageSize[];
  public certifications: Certification[];
  public bulk_packs: BulkPack[] = [];
  public autoclavables: Autoclavable[] = [];
  public necks: Neck[];
  public neck_finishes: NeckFinish[];

  public nalgenes: Nalgene[];

  public storedChemical:string = "";
  public storageTime:string = "";
  public minTemp:number = -1;
  public maxTemp:number = -1;
  public storageSize:number = -1;
  public material:string = "";
  public color:number = 0;
  public shape:number = 0;
  public drain:number = 0;
  public mouthSize:number = 0;
  public certification:number = 0;
  public bulkPack:number = -1;
  public autoclavable:number = -1;
  public neck:number = 0;
  public neckFinish:string = "";

  public filteredNalgenes: Nalgene[] = [];
  public searchString:string = "";

  constructor(public categoryService: CategoryService, public nalgeneService:ProductsService) { }

  ngOnInit() {
    this.getCategories();
    this.getNalgenes();
  }


  getCategories(): void {
    this.categoryService.getCategories().then(categories => {this.categories = categories;
    this.stored_chemicals = categories[0]["stored_chemicals"];
    this.storage_times = categories[1]["storage_times"];
    this.min_temps = categories[2]["min_temps"];
    this.max_temps = categories[3]["max_temps"];
    this.materials = categories[4]["materials"];
    this.colors = categories[5]["colors"];
    this.shapes = categories[6]["shapes"];
    this.drains = categories[7]["drains"];
    this.storage_sizes = categories[8]["storage_sizes"];
    this.certifications = categories[9]["certifications"];
    this.mouth_sizes = categories[10]["mouth_sizes"];
    this.necks = categories[11]["necks"];
    this.neck_finishes = categories[12]["neck_finishes"];

    let bp = new BulkPack();
    bp.id = 0;
    bp.value = "Not Available"
    this.bulk_packs.push(bp);
    let bp1 = new BulkPack();
    bp1.id = 1;
    bp1.value = "Available"
    this.bulk_packs.push(bp1);

    let ac = new Autoclavable();
    ac.id = 0;
    ac.value = "No"
    this.autoclavables.push(ac);


    let ac1 = new Autoclavable();
    ac1.id = 1;
    ac1.value = "Yes"
    this.autoclavables.push(ac1);
   

    });
  }

  getNalgenes(): void {
    this.nalgeneService.getNalgenes().then(nalgenes => {this.nalgenes = nalgenes;
    this.filteredNalgenes = this.nalgenes;
    this.doCategoryCount();});
  }


  storedChemicalChange():void {
    console.log(this.storedChemical);
    //this.storedChemicalSearch(this.storedChemical)
    this.allFilters();
    console.log(this.nalgenes.length)
    console.log(this.filteredNalgenes.length)

    
      
  }

  storagetTimeChange():void {
    //assume that there is a storedChemical selected  Based on data, there must be storedChemical - only thing to search on!
    
    //what should please select do?
    this.allFilters();
  }

  minTempChange():void {
    this.allFilters();
  }
  maxTempChange():void {
    this.allFilters();

  }

  storageSizeChange():void {
    this.allFilters();

  }
  materialChange():void {
   this.allFilters();
  }
  colorChange():void {
    this.allFilters();
  }
  mouthSizeChange():void {
    this.allFilters();
  }
  neckChange():void {
    this.allFilters();
  }
  neckFinishChange():void {
    this.allFilters();
  }

  bulkPackChange():void {
    this.allFilters();
  }

  autoclavableChange():void {
    this.allFilters();
  }

  shapeChange():void{
    this.allFilters();
  }

  drainChange():void {
    console.log("change");
    this.allFilters();
  }

  certificationChange():void {
    console.log(this.certifications);
    this.allFilters();
  }

  searchChange():void {
    console.log(this.searchString);
    this.allFilters();
  }


  allFilters():void{
    //run this with every cnange in search boxes.
    //need to make sure search is valid
    let valid:boolean = true;
    let valid_message:string = "";

    if(this.storedChemical == "" && this.storageTime != ""){
      valid = false;
      valid_message = "You must select a chemical type to be stored";
      this.storageTime = "";
    }

    if(valid){
      this.filteredNalgenes = this.nalgenes;

      if(this.storedChemical != "" && this.storageTime == ""){
        let search = this.storedChemical;
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item[`${search}`] == "E");
        if(this.storageTime == ""){
          console.log ("NO Storage Time");//may need an event to force this - sometimes works!?!
          this.storageTime = "E";
        }

      }

      if (this.storedChemical != "" && this.storageTime != ""){
        let search = this.storedChemical;
        if(this.storageTime == "E"){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item[`${search}`] == "E");
          }
        if(this.storageTime == "G"){
          //this is not a filtered search - need all nalgenes and include "E"
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item[`${search}`] == "E" || item[`${search}`] == "G");

        }
        if(this.storageTime == "F"){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item[`${search}`] == "E" || item[`${search}`] == "G" || item[`${search}`] == "F");
        }
      }

      if(this.minTemp != -1){
        if(this.minTemp == 20){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.min_temp <= this.minTemp)
        }
        if(this.minTemp == 0){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= this.minTemp)
        }
        if(this.minTemp == -40){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= this.minTemp)
        }
        if(this.minTemp == -60){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= this.minTemp)
        }
        if(this.minTemp == -100){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= this.minTemp)
        }
        if(this.minTemp == -135){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= this.minTemp)
        }
        if(this.minTemp == -270){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.min_temp == this.minTemp)
        }
      }
      else {

      }

      if (this.maxTemp != -1){
        if(this.maxTemp == 65){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.max_temp >= 65)
        }
        if(this.maxTemp == 70){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.max_temp >= this.maxTemp && item.min_temp <= 260)
        }
        if(this.maxTemp == 80){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.max_temp >= this.maxTemp && item.min_temp <= 260)
        }
        if(this.maxTemp == 120){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.max_temp >= this.maxTemp && item.min_temp <= 260)
        }
        if(this.maxTemp == 121){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.max_temp >= this.maxTemp && item.min_temp <= 260)
        }
        if(this.maxTemp == 135){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.max_temp >= this.maxTemp && item.min_temp <= 260)
        }
        if(this.maxTemp == 145){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.max_temp >= this.maxTemp && item.min_temp <= 260)
        }

        if(this.maxTemp == 205){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.max_temp >= this.maxTemp && item.min_temp <= 260)
        }

        if(this.maxTemp == 260){
          this.filteredNalgenes = this.filteredNalgenes.filter(item => item.max_temp == this.maxTemp)
        }

      }
      else{

      }
      if(this.storageSize != - 1){
        console.log(this.storageSize);
        this.filteredNalgenes = this.filteredNalgenes.filter(item => parseFloat(item.size_in_ml) == this.storageSize)
      }

      if (this.material != ""){
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item.material.code == this.material)

      }
      else{

      }
      if(this.color != 0){
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item.color.id == this.color)
      }
      else {

      }
      if(this.shape != 0){
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item.shape.id == this.shape)
      }
      else {

      }
      if(this.mouthSize != 0){
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item.mouth_size.id == this.mouthSize)
      }
      else {

      }
      if(this.drain != 0){
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item.drain.id == this.drain)
      }
      else {

      }
      if (this.neck !=0){
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item.neck_id == this.neck);
      }
      else {

      }

      if (this.neckFinish !=""){
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item.neck_finish == this.neckFinish);
      }
      else {

      }
      if(this.bulkPack != -1){
        let val:boolean = false;
        if(this.bulkPack == 1){
        val = true
        }
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item.bulk_pack == val)
      }
      else {
  
      }

      if(this.autoclavable != -1){
        let val:boolean = false;
        if(this.autoclavable == 1){
        val = true
        }
        this.filteredNalgenes = this.filteredNalgenes.filter(item => item.autoclavable == val)
      }
      else {
  
      }

      //now look at multiple select certs
       //2nd cut have an array of certifcations that are checked
       let selected:Certification[]= [];
       selected = this.certifications.filter(item => item.checked);
        //console.log(selected);
       if (selected.length != 0){
       let certNalgenes:Nalgene[] = [];
        // selected.forEach(item => { 
        //   this.filteredNalgenes.forEach(nalgene => {
        //     nalgene.certifications.forEach(certification => {
        //       if(certification.id == item.id){
        //         if(certNalgenes.includes(nalgene)){
        //           console.log("true")
        //         }
        //         else{
        //           certNalgenes.push(nalgene);
        //         }
        //       }
        //     });
        //   });
        // });
        // this.filteredNalgenes = certNalgenes;
        //3rd Cut only include skus that contain each of the certificates
       this.filteredNalgenes.forEach(item => {
         let count:number = 0;

         selected.forEach(sel => {
           console.log(sel)
           let certs = item.certifications.map(cert => {return cert.id})
           console.log(certs);
           if(certs.includes(sel.id)){
             count = count + 1
           }
         })
         console.log(count);
         if(count == selected.length){
           certNalgenes.push(item);
         }
       })
       this.filteredNalgenes = certNalgenes;
       }
       else {

       }

       this.filteredNalgenes = this.filteredNalgenes.filter(item => item.sku.concat(item.title).toLowerCase().includes(this.searchString.toLowerCase()));
       
       //if we have a stored chemical, we need to sort it by rating, E, G, F
       if(this.storedChemical != ""){
         //filteredNalgenes contains ratings with E, and, G or F.
          //need to add the rating to each sku based on the chemical selected value
          this.filteredNalgenes.forEach(nalgene => {
            nalgene.rating = nalgene[`${this.storedChemical}`]
          })

        if(this.storageTime != "E"){
          
          let eNalgenes:Nalgene[] = [];
          let gNalgenes:Nalgene[] = [];
          let fNalgenes:Nalgene[] = [];
          let comboNalgenes:Nalgene[] = [];
          eNalgenes = this.filteredNalgenes.filter(item => item.rating == "E")
          gNalgenes = this.filteredNalgenes.filter(item => item.rating == "G")
          fNalgenes = this.filteredNalgenes.filter(item => item.rating == "F")
          if(this.storageTime == "G"){
            comboNalgenes = eNalgenes.concat(gNalgenes);
          }
          if(this.storageTime == "F"){
            comboNalgenes = eNalgenes.concat(gNalgenes).concat(fNalgenes);
          }
          
          this.filteredNalgenes = comboNalgenes;
        }
       }
    }
    

    else{
      alert(valid_message);
      this.resetFilters();
    }
    this.doCategoryCount();
  }


//two methods below for experimenting.
  storedChemicalSearch(search:string):void{
    if(search == ""){
      this.filteredNalgenes = this.nalgenes
      this.storageTime = "";
    }
    else {
      this.filteredNalgenes = this.nalgenes.filter(item => item[`${search}`] == "E");
      this.storageTime = "E";
    }

  }
 

  resetFilters():void {
    // need to determine if other items are sticky
    this.storedChemical = ""
    this.storageTime = ""

    this.minTemp = -1;
    this.maxTemp = -1;
    this.storageSize = -1;
    this.material= "";
    this.color = 0;
    this.shape = 0;
    this.drain = 0;
    this.mouthSize = 0;
    this.certification = 0;
    this.bulkPack = -1;
    this.autoclavable = -1;
    this.searchString = "";
    this.neck = 0;
    this.neckFinish = "";
    this.filteredNalgenes = this.nalgenes;

    this.filteredNalgenes.forEach(n => n.rating = "N/A");

    this.certifications.filter(item => item.checked = false);
    this.doCategoryCount();

    
  }

  doCategoryCount():void{
    this.min_temps.forEach(mt => {
      mt.count = this.filteredNalgenes.filter(nalgene => nalgene.min_temp == mt.tempature).length
    })

    //with temps, as they use a range, need to look at the total count within the range
    this.max_temps.forEach(mt => {
      if(mt.tempature == 65){
      mt.count = this.filteredNalgenes.filter(item => item.max_temp >= mt.tempature).length
      }
      if(mt.tempature == 70){
        mt.count = this.filteredNalgenes.filter(item => item.max_temp >= mt.tempature && item.min_temp <= 260).length
      }
      if(mt.tempature == 80){
        mt.count = this.filteredNalgenes.filter(item => item.max_temp >=  mt.tempature && item.min_temp <= 260).length
      }
      if(mt.tempature == 120){
        mt.count = this.filteredNalgenes.filter(item => item.max_temp >= mt.tempature && item.min_temp <= 260).length
      }
      if(mt.tempature == 121){
        mt.count = this.filteredNalgenes.filter(item => item.max_temp >= mt.tempature && item.min_temp <= 260).length
      }
      if(mt.tempature == 135){
        mt.count = this.filteredNalgenes.filter(item => item.max_temp >= mt.tempature && item.min_temp <= 260).length
      }
      if(mt.tempature == 145){
        mt.count = this.filteredNalgenes.filter(item => item.max_temp >= mt.tempature && item.min_temp <= 260).length
      }

      if(mt.tempature == 205){
        mt.count = this.filteredNalgenes.filter(item => item.max_temp >= mt.tempature && item.min_temp <= 260).length
      }

      if(mt.tempature == 260){
        mt.count = this.filteredNalgenes.filter(item => item.max_temp == mt.tempature).length
      }
    })

    this.min_temps.forEach(mt => {
      mt.count = this.filteredNalgenes.filter(nalgene => nalgene.min_temp == mt.tempature).length
      if(mt.tempature == 20){
        mt.count = this.filteredNalgenes.filter(item => item.min_temp <= mt.tempature).length;
      }
      if(mt.tempature == 0){
        mt.count = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= mt.tempature).length
      }
      if(mt.tempature == -40){
        mt.count = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= mt.tempature).length
      }
      if(mt.tempature == -60){
        mt.count = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= mt.tempature).length
      }
      if(mt.tempature == -100){
        mt.count = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= mt.tempature).length
      }
      if(mt.tempature == -135){
        mt.count = this.filteredNalgenes.filter(item => item.min_temp >= -270 && item.min_temp <= mt.tempature).length
      }
      if(mt.tempature == -270){
        mt.count = this.filteredNalgenes.filter(item => item.min_temp == mt.tempature).length
      }
    })

    this.storage_sizes.forEach(sz => {
      sz.count = this.filteredNalgenes.filter(nalgene => parseFloat(nalgene.size_in_ml) == sz.size).length
    })
    this.bulk_packs.forEach(bp => {
      let val:boolean = false;
        if(bp.value == "Available"){
        val = true
        }
      bp.count = this.filteredNalgenes.filter(nalgene => nalgene.bulk_pack == val).length
    })
    this.autoclavables.forEach(ac => {
      let val:boolean = false;
        if(ac.value == "Yes"){
        val = true
        }
      ac.count = this.filteredNalgenes.filter(nalgene => nalgene.autoclavable == val).length
    })
    this.materials.forEach(mat => {
      mat.count = this.filteredNalgenes.filter(nalgene => nalgene.material.code == mat.code).length
    })

    this.shapes.forEach(shape => {
      shape.count = this.filteredNalgenes.filter(nalgene => nalgene.shape.id == shape.id).length
    })
    this.colors.forEach(color => {
      color.count = this.filteredNalgenes.filter(nalgene => nalgene.color.id == color.id).length
    })
    this.drains.forEach(drain => {
      drain.count = this.filteredNalgenes.filter(nalgene => nalgene.drain.id == drain.id).length
    })
    this.mouth_sizes.forEach(ms => {
      ms.count = this.filteredNalgenes.filter(nalgene => nalgene.mouth_size.id == ms.id).length
    })
    this.necks.forEach(neck => {
      neck.count = this.filteredNalgenes.filter(nalgene => nalgene.neck_id == neck.value).length;
    })
    this.neck_finishes.forEach(neck_finish => {
      neck_finish.count = this.filteredNalgenes.filter(nalgene => nalgene.neck_finish == neck_finish.value).length;
    })
    this.certifications.forEach(cert => {
      let count:number = 0;
      this.filteredNalgenes.forEach(nal => { 
        nal.certifications.forEach(nal_cert => {
          if (nal_cert.id == cert.id){
          count = count + 1; 
          }
        })
      })
      cert.count = count;
    });

    
      

  }
  




}


// WEBPACK FOOTER //
// /Users/thomas.obrien2/projects/nalgene/src/app/categories/categories.component.ts